import React, { Suspense, lazy } from 'react';
import { Hero } from '../components/Hero';
import { SocialProofTicker } from '../components/SocialProofTicker';
const ActionKit = lazy(() => import('../components/ActionKit').then(m => ({
  default: m.ActionKit
})));
const Testimonials = lazy(() => import('../components/Testimonials').then(m => ({
  default: m.Testimonials
})));
const ChapterList = lazy(() => import('../components/ChapterList').then(m => ({
  default: m.ChapterList
})));
const Pricing = lazy(() => import('../components/Pricing').then(m => ({
  default: m.Pricing
})));
const FAQ = lazy(() => import('../components/FAQ').then(m => ({
  default: m.FAQ
})));
const ShareSection = lazy(() => import('../components/ShareSection').then(m => ({
  default: m.ShareSection
})));
const Footer = lazy(() => import('../components/Footer').then(m => ({
  default: m.Footer
})));
export function LandingPage() {
  return <div className="min-h-screen bg-[#1a56a0] text-white overflow-x-hidden" data-id="element-223">
      <Hero data-id="element-224" />
      <SocialProofTicker data-id="element-225" />
      <Suspense fallback={<div className="h-32" data-id="element-227" />} data-id="element-226">
        <ActionKit data-id="element-228" />
      </Suspense>
      <Suspense fallback={<div className="h-32" data-id="element-230" />} data-id="element-229">
        <Testimonials data-id="element-231" />
      </Suspense>
      <Suspense fallback={<div className="h-32" data-id="element-233" />} data-id="element-232">
        <ChapterList data-id="element-234" />
      </Suspense>
      <Suspense fallback={<div className="h-32" data-id="element-236" />} data-id="element-235">
        <Pricing data-id="element-237" />
      </Suspense>
      <Suspense fallback={<div className="h-32" data-id="element-239" />} data-id="element-238">
        <FAQ data-id="element-240" />
      </Suspense>
      <Suspense fallback={<div className="h-32" data-id="element-242" />} data-id="element-241">
        <ShareSection data-id="element-243" />
      </Suspense>
      <Suspense fallback={<div className="h-32" data-id="element-245" />} data-id="element-244">
        <Footer data-id="element-246" />
      </Suspense>
    </div>;
}